/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomFieldValueRead } from './CustomFieldValueRead';
import {
  CustomFieldValueReadFromJSON,
  CustomFieldValueReadFromJSONTyped,
  CustomFieldValueReadToJSON,
} from './CustomFieldValueRead';

/**
 *
 * @export
 * @interface PaginatedCustomFieldValueReadList
 */
export interface PaginatedCustomFieldValueReadList {
  /**
   *
   * @type {number}
   * @memberof PaginatedCustomFieldValueReadList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedCustomFieldValueReadList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedCustomFieldValueReadList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<CustomFieldValueRead>}
   * @memberof PaginatedCustomFieldValueReadList
   */
  results: Array<CustomFieldValueRead>;
}

/**
 * Check if a given object implements the PaginatedCustomFieldValueReadList interface.
 */
export function instanceOfPaginatedCustomFieldValueReadList(value: object): value is PaginatedCustomFieldValueReadList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedCustomFieldValueReadListFromJSON(json: any): PaginatedCustomFieldValueReadList {
  return PaginatedCustomFieldValueReadListFromJSONTyped(json, false);
}

export function PaginatedCustomFieldValueReadListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedCustomFieldValueReadList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(CustomFieldValueReadFromJSON),
  };
}

export function PaginatedCustomFieldValueReadListToJSON(value?: PaginatedCustomFieldValueReadList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(CustomFieldValueReadToJSON),
  };
}
